"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityPanel = exports.EntityPanelDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var icon_label_1 = require("../elements/icon-label");
var icons_1 = require("@shapeable/icons");
var entity_value_1 = require("./entity-value");
var cls = (0, utils_1.classNames)('entity-panel');
exports.EntityPanelDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    /* border: 1px solid ", ";\n    border-radius: ", "; */\n    padding: ", " ", " ", " ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    /* border: 1px solid ", ";\n    border-radius: ", "; */\n    padding: ", " ", " ", " ", ";\n  "])), theme_1.theme.UNIT(6), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3))
});
var IconTitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 1.4em;\n    font-weight: 500;\n    ", ";\n  "], ["\n    color: ", ";\n    font-size: 1.4em;\n    font-weight: 500;\n    ", ";\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.FILL('primary'))
});
var ValuesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MetaStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconTitle: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconTitleStyles),
  Meta: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), MetaStyles),
  Values: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ValuesStyles)
};
var EntityPanel = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    meta = props.meta,
    title = props.title;
  var hasMeta = props.meta !== undefined;
  var hasTitle = !!title;
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, hasTitle && react_1.default.createElement(My.IconTitle, {
    iconSize: 38,
    icon: react_1.default.createElement(icons_1.LayoutIcon, null)
  }, title), hasMeta && react_1.default.createElement(My.Meta, null, meta), children);
};
exports.EntityPanel = EntityPanel;
exports.EntityPanel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;